/**
 * DetailMetadataContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled detail metadata container.
 */
const DetailMetadataContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: ${1052 * Screen.widthRatio}px;
  top: ${604 * Screen.widthRatio}px;
`;

export default DetailMetadataContainer;
